/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApproveWithdrawTransactionDto,
    BatchApproveWithdrawTransactionResponse,
    BatchApproveWithdrawTransactionsDto,
    CreateWithdrawByAdminDto,
    CreateWithdrawDto,
    GetMyPayoutsResponse,
    RejectWithdrawTransactionDto,
    WithdrawTransactionResponse,
} from '../models';

export interface WithdrawTransactionApiControllerApproveWithdrawRequest {
    withdrawTransactionId: string;
    approveWithdrawTransactionDto: ApproveWithdrawTransactionDto;
}

export interface WithdrawTransactionApiControllerBatchApproveWithdrawRequest {
    batchApproveWithdrawTransactionsDto: BatchApproveWithdrawTransactionsDto;
}

export interface WithdrawTransactionApiControllerCreateWithdrawRequest {
    userId: string;
    createWithdrawDto: CreateWithdrawDto;
}

export interface WithdrawTransactionApiControllerCreateWithdrawByAdminRequest {
    createWithdrawByAdminDto: CreateWithdrawByAdminDto;
}

export interface WithdrawTransactionApiControllerGetMyWithdrawTransactionsRequest {
    sellerId: string;
    limit?: number;
    lastDocId?: string;
}

export interface WithdrawTransactionApiControllerRejectWithdrawRequest {
    withdrawTransactionId: string;
    rejectWithdrawTransactionDto: RejectWithdrawTransactionDto;
}

/**
 * 
 */
export class WithdrawTransactionApi extends runtime.BaseAPI {

    /**
     */
    async withdrawTransactionApiControllerApproveWithdrawRaw(requestParameters: WithdrawTransactionApiControllerApproveWithdrawRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.withdrawTransactionId === null || requestParameters.withdrawTransactionId === undefined) {
            throw new runtime.RequiredError('withdrawTransactionId','Required parameter requestParameters.withdrawTransactionId was null or undefined when calling withdrawTransactionApiControllerApproveWithdraw.');
        }

        if (requestParameters.approveWithdrawTransactionDto === null || requestParameters.approveWithdrawTransactionDto === undefined) {
            throw new runtime.RequiredError('approveWithdrawTransactionDto','Required parameter requestParameters.approveWithdrawTransactionDto was null or undefined when calling withdrawTransactionApiControllerApproveWithdraw.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/withdraw-transactions/{withdrawTransactionId}:approve`.replace(`{${"withdrawTransactionId"}}`, encodeURIComponent(String(requestParameters.withdrawTransactionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.approveWithdrawTransactionDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async withdrawTransactionApiControllerApproveWithdraw(requestParameters: WithdrawTransactionApiControllerApproveWithdrawRequest): Promise<void> {
        await this.withdrawTransactionApiControllerApproveWithdrawRaw(requestParameters);
    }

    /**
     */
    async withdrawTransactionApiControllerBatchApproveWithdrawRaw(requestParameters: WithdrawTransactionApiControllerBatchApproveWithdrawRequest): Promise<runtime.ApiResponse<BatchApproveWithdrawTransactionResponse>> {
        if (requestParameters.batchApproveWithdrawTransactionsDto === null || requestParameters.batchApproveWithdrawTransactionsDto === undefined) {
            throw new runtime.RequiredError('batchApproveWithdrawTransactionsDto','Required parameter requestParameters.batchApproveWithdrawTransactionsDto was null or undefined when calling withdrawTransactionApiControllerBatchApproveWithdraw.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/withdraw-transactions:batch-approve`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchApproveWithdrawTransactionsDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async withdrawTransactionApiControllerBatchApproveWithdraw(requestParameters: WithdrawTransactionApiControllerBatchApproveWithdrawRequest): Promise<BatchApproveWithdrawTransactionResponse> {
        const response = await this.withdrawTransactionApiControllerBatchApproveWithdrawRaw(requestParameters);
        return await response.value();
    }

    /**
     * for sellers to use inside the app
     */
    async withdrawTransactionApiControllerCreateWithdrawRaw(requestParameters: WithdrawTransactionApiControllerCreateWithdrawRequest): Promise<runtime.ApiResponse<WithdrawTransactionResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling withdrawTransactionApiControllerCreateWithdraw.');
        }

        if (requestParameters.createWithdrawDto === null || requestParameters.createWithdrawDto === undefined) {
            throw new runtime.RequiredError('createWithdrawDto','Required parameter requestParameters.createWithdrawDto was null or undefined when calling withdrawTransactionApiControllerCreateWithdraw.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/withdraw-transactions`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createWithdrawDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for sellers to use inside the app
     */
    async withdrawTransactionApiControllerCreateWithdraw(requestParameters: WithdrawTransactionApiControllerCreateWithdrawRequest): Promise<WithdrawTransactionResponse> {
        const response = await this.withdrawTransactionApiControllerCreateWithdrawRaw(requestParameters);
        return await response.value();
    }

    /**
     * only for admin page
     */
    async withdrawTransactionApiControllerCreateWithdrawByAdminRaw(requestParameters: WithdrawTransactionApiControllerCreateWithdrawByAdminRequest): Promise<runtime.ApiResponse<WithdrawTransactionResponse>> {
        if (requestParameters.createWithdrawByAdminDto === null || requestParameters.createWithdrawByAdminDto === undefined) {
            throw new runtime.RequiredError('createWithdrawByAdminDto','Required parameter requestParameters.createWithdrawByAdminDto was null or undefined when calling withdrawTransactionApiControllerCreateWithdrawByAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/withdraw-transactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createWithdrawByAdminDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * only for admin page
     */
    async withdrawTransactionApiControllerCreateWithdrawByAdmin(requestParameters: WithdrawTransactionApiControllerCreateWithdrawByAdminRequest): Promise<WithdrawTransactionResponse> {
        const response = await this.withdrawTransactionApiControllerCreateWithdrawByAdminRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async withdrawTransactionApiControllerGetMyWithdrawTransactionsRaw(requestParameters: WithdrawTransactionApiControllerGetMyWithdrawTransactionsRequest): Promise<runtime.ApiResponse<GetMyPayoutsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling withdrawTransactionApiControllerGetMyWithdrawTransactions.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.lastDocId !== undefined) {
            queryParameters['lastDocId'] = requestParameters.lastDocId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/withdraw-transactions`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async withdrawTransactionApiControllerGetMyWithdrawTransactions(requestParameters: WithdrawTransactionApiControllerGetMyWithdrawTransactionsRequest): Promise<GetMyPayoutsResponse> {
        const response = await this.withdrawTransactionApiControllerGetMyWithdrawTransactionsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async withdrawTransactionApiControllerRejectWithdrawRaw(requestParameters: WithdrawTransactionApiControllerRejectWithdrawRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.withdrawTransactionId === null || requestParameters.withdrawTransactionId === undefined) {
            throw new runtime.RequiredError('withdrawTransactionId','Required parameter requestParameters.withdrawTransactionId was null or undefined when calling withdrawTransactionApiControllerRejectWithdraw.');
        }

        if (requestParameters.rejectWithdrawTransactionDto === null || requestParameters.rejectWithdrawTransactionDto === undefined) {
            throw new runtime.RequiredError('rejectWithdrawTransactionDto','Required parameter requestParameters.rejectWithdrawTransactionDto was null or undefined when calling withdrawTransactionApiControllerRejectWithdraw.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/withdraw-transactions/{withdrawTransactionId}:reject`.replace(`{${"withdrawTransactionId"}}`, encodeURIComponent(String(requestParameters.withdrawTransactionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.rejectWithdrawTransactionDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async withdrawTransactionApiControllerRejectWithdraw(requestParameters: WithdrawTransactionApiControllerRejectWithdrawRequest): Promise<void> {
        await this.withdrawTransactionApiControllerRejectWithdrawRaw(requestParameters);
    }

}
